const LocalesLocationEnum = Object.freeze({
  French: 'sites-de-production',
  German: 'standorte',
  Czech: 'lokality',
  Slovak: 'lokality',
  Spanish: 'centros-de-producción',
})

export default LocalesLocationEnum
